import {
  Component,
  Input,
  OnChanges,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { BadgeReturnType } from './badge.types';
import { badgeProps } from './badge.utils';

@Component({
  selector: 'cohrex-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BadgeComponent implements OnChanges, OnInit {
  props?: BadgeReturnType;

  private _color?: string = 'primary';
  @Input()
  set color(value: string | undefined) {
    this._color = value;
  }
  get color(): string | undefined {
    return this._color;
  }

  private _isPill?: boolean = false;
  @Input()
  set isPill(value: boolean | undefined) {
    this._isPill = value;
  }
  get isPill(): boolean | undefined {
    return this._isPill;
  }

  @Input() small: boolean = false;

  ngOnInit(): void {
    this.initProps();
  }

  ngOnChanges(): void {
    this.initProps();
  }

  initProps() {
    this.props = badgeProps({
      color: this.color,
      isPill: this.isPill
    });
  }
}
